import { styled, css } from "@mui/material";

export const MDXStyles = styled("div")(({ theme }) => {
  return css`
    display: flex;
    flex-direction: column;

    ${theme.breakpoints.up("mobile")} {
      gap: 8px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      gap: 16px;
    }
  `;
});

export const WorkersContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    gap: 1rem;
    justify-content: center;

    ${theme.breakpoints.up("mobile")} {
      flex-direction: column;
      align-items: center;
      margin: 0 24px;
    }

    ${theme.breakpoints.up("tablet")} {
      flex-direction: row;
      align-items: normal;
    }
    ${theme.breakpoints.up("desktop")} {
      flex-direction: row;
      align-items: normal;
      margin: 0 48px;
    }
  `,
);
